import React from 'react';
import ProgressBar from '../ProgressBar';
import styles from './SummaryProgressCard.module.css';

export default function SummaryProgressCard({ label, value, percentage = 0, details = [], side, extraStats = [], dangerPercentage = 0, hideProgressBar = false }) {
  return (
    <div className={styles.container}>
      <div className={styles.main}>
        <div className={styles.volumeSection}>
          <div className={styles.volumeHeader}>
            <div>
              <span className={styles.label}>{label}</span>
              <span className={styles.volumeValue}>{value}</span>
            </div>
            {extraStats.map((stat, index) => (
              <div key={index}>
                <span className={styles.label}>{stat.label}</span>
                <span className={`${styles.volumeValue} ${stat.danger ? styles.volumeValueDanger : ''}`}>{stat.value}</span>
              </div>
            ))}
          </div>
          {!hideProgressBar && (
            <ProgressBar percentage={percentage} height="tall" dangerPercentage={dangerPercentage} />
          )}
          <div className={styles.volumeDetails}>
            {details.map((detail, index) => (
              <div key={index} className={styles.detailItem}>
                <span className={styles.detailLabel}>{detail.label}</span>
                <span className={styles.detailValue}>{detail.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {side && (
        <div className={styles.sidebar}>
          <h3 className={styles.sidebarTitle}>{side.title}</h3>
          <div className={styles.sidebarItems}>
            {side.items.map((item, index) => (
              <div key={index} className={styles.sidebarItem}>
                <div className={styles.sidebarProgressHeader}>
                  <span className={styles.sidebarLabel}>{item.label}</span>
                  <span className={styles.sidebarValue}>{item.value}</span>
                </div>
                {item.percentage != null && <ProgressBar percentage={item.percentage} />}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
